// LogoutButton.tsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from '../../firebase';

const LogoutButton = () => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    await signOut(auth);
    navigate('/login');
  };

  return (
    <button
      onClick={handleLogout}
      className="app-button-secondary mt-4 rounded-xl border px-4 py-2 text-sm font-bold transition hover:bg-white/[0.08]"
    >
      Sign Out
    </button>
  );
};

export default LogoutButton;
